import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    fill: 'currentColor',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fontSize: '1.5rem',
    flexShrink: 0,
  },
}));

export default useStyles;
